/**
 * English fallbacks when the translation API has not loaded or omits a key.
 * Keeps Pixi text from showing raw keywords in dev/offline.
 */
import { slotCasinoStringsEn } from './slotCasinoStrings.en.js';

export const translationFallbackEn = slotCasinoStringsEn;
